
import AppChatConversation from "@/components/chat/ChatConversation.vue";
import { Conversation } from "@/models/chat/conversation";
import { ConversationGroup } from "@/models/chat/conversation-group";
import { ChatService } from "@/services/chat-service";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			conversation: new Conversation(),
			conversationGroups: [] as ConversationGroup[],
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	watch: {
		"$route.params.threadId"(to, from) {
			this.fetch();
		}
	},
	methods: {
		async fetch() {
			this.conversation = await ChatService.getThreadConversation(this.$route.params.threadId);
		}
	},
	created() {
		this.fetch();
	},
	components: {
		AppChatConversation
	},
	i18nEx: {}
});
